import { Modal } from 'react-bootstrap';

import { JSONEditor } from '../../components/JSONEditor/JSONEditor';
import { EditorStatusSelect } from '../../components/EditorStatusSelect/EditorStatusSelect';
import { EditorCommentInput } from '../../components/EditorCommentInput/EditorCommentInput';
import { EditorSubmitButton } from '../../components/EditorSubmitButton/EditorSubmitButton';

export const SupportEventOrchestrator = () => (
  <>
    <Modal.Body>
      <div className="d-flex gap-2 align-items-start">
        <JSONEditor />
        <div className="d-flex flex-column gap-2">
          <EditorStatusSelect />
          <EditorCommentInput />
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <EditorSubmitButton />
    </Modal.Footer>
  </>
);
